import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import { JsonLd, medicalBusinessSchema, physicianSchema } from "@/components/StructuredData";
import { CLINIC } from "@/lib/clinicInfo";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <>
      {/* Site-wide structured data */}
      <JsonLd data={medicalBusinessSchema(CLINIC)} />
      <JsonLd data={physicianSchema(CLINIC)} />
      <Header />
      <main className="min-h-[60vh]">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFAB />
    </>
  );
}
